/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge3 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important; 
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id}  delimiter-edge-11`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		> 
			<path fillRule="evenodd" clipRule="evenodd" enableBackground="new" fill={props.item.fill || "var(--force-contast-color)"}  d="M229.5,7.2c0.2,0,0.3,0,0.5,0c3.3,2.6,6.5,5.2,9.9,7.8c3.3-2.6,6.6-5.2,9.9-7.8c0.2,0,0.4,0,0.6,0
				c3.2,2.6,6.5,5.1,9.8,7.6c3.3-2.5,6.6-5,9.8-7.6c0.2,0,0.4,0,0.6,0c3.6,2.8,7.2,5.7,10.8,8.5c1.8-1.2,3.7-2,5.8-2.6
				c8.4-2.1,16.8-2.4,25.3-0.9c5.8,1.1,11.6,2.6,17.2,4.5c4.6,1.6,9.2,3.2,13.8,4.8c3.4,1,6.8,1.6,10.2,2c4.4,0.1,8.9,0.1,13.3,0
				c5-1,9-3.6,11.9-7.8c0.8-1.2,1.5-2.5,2.3-3.7c2.1,3.8,2.2,7.6,0.2,11.5c7.3,0.2,14.7,0.2,22,0.1c1.2-3.4,3.6-4.8,7.1-4.2
				c2.3,0.6,3.7,2,4.2,4.3c26.6,0,53.2,0,79.8,0c0,0.5,0,1,0,1.6c-26.6-0.1-53.2,0-79.8,0.2c-0.9,2.8-2.7,4.2-5.7,4.2
				c-2.9-0.1-4.8-1.5-5.7-4.3c-7.3-0.1-14.7-0.1-22,0.1c2,3.8,2,7.7-0.2,11.5c-2.2-4.5-5.4-7.9-9.8-10.3c-1.4-0.6-2.8-1-4.3-1.2
				c-4.4-0.1-8.9-0.1-13.3,0c-3.3,0.4-6.6,1-9.8,1.9c-7.5,2.7-15,5.2-22.7,7.4c-6,1.7-12.2,2.7-18.5,3c-5.3,0-10.5-0.6-15.7-1.9
				c-2.1-0.6-4-1.4-5.8-2.6c-3.6,2.9-7.2,5.7-10.8,8.5c-0.2,0-0.4,0-0.6,0c-2.9-2.3-5.8-4.6-8.7-6.9c-0.3-0.3-0.7-0.5-1.2-0.7
				c-3.3,2.4-6.5,5-9.7,7.6c-0.2,0-0.4,0-0.6,0c-3.3-2.6-6.5-5.2-9.9-7.8c-3.3,2.6-6.6,5.2-9.9,7.8c-0.2,0-0.3,0-0.5,0
				c-3.6-2.8-7.2-5.6-10.9-8.4c-3.7,1.9-7.6,3.1-11.8,3.6c-7,1-14,0.8-20.9-0.6c-4.9-1.1-9.8-2.3-14.6-3.9c-4.9-1.6-9.9-3.4-14.7-5.1
				c-3.4-1-6.8-1.6-10.2-2c-4.4-0.1-8.9-0.1-13.3,0c-2.8,0.4-5.2,1.4-7.4,3.1c-2.9,2.3-5.1,5.2-6.8,8.5c-2.1-3.8-2.2-7.7-0.1-11.6
				c-7.4-0.1-14.8-0.1-22.2-0.1c-0.8,2.9-2.7,4.3-5.7,4.3c-3,0-4.8-1.5-5.5-4.3c-26.6,0-53.2,0-79.8,0c0-0.5,0-1,0-1.6
				c26.6,0,53.2,0,79.8,0c0.7-2.9,2.6-4.3,5.6-4.3c3,0,4.8,1.5,5.6,4.3c7.4,0,14.8,0,22.2-0.1c-2.1-3.9-2-7.7,0.1-11.6
				c2.2,4.6,5.6,8.1,10.2,10.5c1.3,0.6,2.6,0.9,4,1.1c4.4,0.1,8.8,0.1,13.2,0c3.7-0.4,7.3-1.1,10.9-2.2c7.3-2.7,14.7-5.2,22.2-7.3
				c5.9-1.7,11.9-2.6,18.1-2.9c5.3,0,10.5,0.6,15.6,1.9c2,0.6,3.9,1.4,5.7,2.4C222.3,12.9,225.9,10.1,229.5,7.2z M229.7,10.3
				c2.7,2.1,5.4,4.2,8.1,6.3c-2.7,2-5.3,4.1-8,6.1c-2.7-2-5.3-4.1-8-6.1C224.4,14.5,227,12.4,229.7,10.3z M249.8,10.3
				c2.7,2,5.4,4.1,8.1,6.2c-2.5,2.2-5.2,4.2-7.9,6.2c-2.7-2-5.4-4.1-8.1-6.1C244.6,14.6,247.3,12.5,249.8,10.3z M270,10.5
				c0.2,0,0.3,0,0.5,0.1c2.5,2.1,5.1,4.1,7.8,6.1c-2.7,2.1-5.4,4.1-8.1,6.1c-2.7-2-5.4-4-7.9-6.2C264.9,14.5,267.4,12.5,270,10.5z
				M194.1,14.2c3.8-0.1,7.6,0.1,11.3,0.5c2.5,0.4,5,1.1,7.3,2.2c0.2,0.2,0.2,0.3,0,0.5c-1.9,1.5-4,2.7-6.4,3.6
				c-3.6,1.2-7.3,2.1-11,2.6c-2.4,0.1-4.9,0.1-7.3-0.1c-1-2.2-2.6-3-5-2.4c-2.5,1-3.2,2.7-2.1,5.2c1.7,1.8,3.7,2.1,5.8,0.9
				c0.6-0.5,1-1.1,1.2-1.8c7.6-0.5,14.8,0.8,21.7,4.1c1,0.6,2.1,1.3,3,2.1c0.1,0.1,0.1,0.2-0.1,0.3c-3.6,1.6-7.5,2.5-11.5,2.7
				c-7.4,0.3-14.7-0.5-21.9-2.5c-8.8-2.4-17.5-5-26.2-7.7c10.7-3.4,21.5-6.5,32.4-9.1C188.5,14.9,191.3,14.5,194.1,14.2z M298.6,14.2
				c6.1-0.2,12.2,0.3,18.2,1.6c10.1,2.6,20.1,5.4,29.9,8.6c-9.4,3-19,5.8-28.6,8.3c-7,1.7-14.1,2.3-21.3,1.7c-3.5-0.3-6.8-1.2-9.9-2.6
				c1.7-1.6,3.7-2.8,5.9-3.6c6.1-2.4,12.5-3.4,19.1-3c0.5,1.8,1.8,2.7,3.6,2.8c3-0.4,4.2-2,3.6-5c-1.1-1.8-2.8-2.5-4.9-1.9
				c-1.3,0.4-2.1,1.2-2.3,2.6c-6.8,0.4-13.3-0.7-19.6-3.2c-2-0.8-3.9-1.9-5.4-3.4C290.7,15.4,294.5,14.5,298.6,14.2z M218.3,17.5
				c0.4,0.1,0.8,0.3,1.1,0.5c2.7,2.1,5.4,4.3,8.1,6.4c-2.9,2.4-5.9,4.7-9,7c-1.9-2.1-4.2-3.5-6.8-4.4c-3.9-1.3-7.8-2.2-11.8-2.6
				c4-0.4,8-1.2,11.8-2.5c2.1-0.8,4-1.9,5.7-3.3C217.8,18.3,218.1,17.9,218.3,17.5z M281.2,17.5c1.1,1.1,2.4,2,3.7,2.9
				c4.8,2.4,9.9,3.7,15.2,4c-3.9,0.5-7.7,1.3-11.5,2.5c-2.8,1-5.2,2.5-7.3,4.6c-3-2.3-6-4.7-9-7C275.3,22.2,278.3,19.8,281.2,17.5z
				M239.8,18.2c2.7,2,5.4,4.1,8.1,6.2c-2.6,2.1-5.3,4.2-8,6.2c-2.7-2-5.3-4.1-7.8-6.2C234.5,22.3,237.1,20.2,239.8,18.2z M259.9,18.2
				c2.7,2,5.4,4.1,8.1,6.2c-2.6,2.1-5.3,4.2-8,6.2c-2.6-2.1-5.2-4.2-7.8-6.2C254.8,22.4,257.4,20.4,259.9,18.2z M90.6,20.9
				c3,0.2,4.3,1.7,4,4.7c-0.7,1.6-2,2.4-3.7,2.5c-2.9-0.4-4.1-2-3.6-4.8C88,21.9,89.1,21.1,90.6,20.9z M408.7,20.9
				c2.3,0.1,3.7,1.3,4.2,3.6c-0.5,2.1-1.8,3.3-4,3.6c-3.3-0.5-4.4-2.3-3.3-5.4C406.5,21.6,407.5,21,408.7,20.9z M229.5,26.2
				c0.2,0,0.3,0,0.5,0.1c2.5,2.1,5.1,4.1,7.8,6.1c-2.7,2-5.4,4.1-8,6.3c-2.7-2.1-5.3-4.2-8-6.3C224.4,30.3,227,28.2,229.5,26.2z
				M249.8,26.2c2.8,1.9,5.5,4,8.1,6.1c-2.6,2.2-5.3,4.2-8,6.3c-2.6-2.2-5.3-4.2-8-6.3C244.6,30.3,247.2,28.2,249.8,26.2z M270,26.2
				c0.2,0,0.4,0.1,0.6,0.2c2.5,2,5,4,7.6,5.9c-2.7,2-5.3,4.1-8,6.1c-2.7-1.9-5.4-3.9-8-6.1C264.8,30.2,267.4,28.2,270,26.2z"/>
		</svg>
	</div>
}

